import { cn } from '@repo/tailwind-config/tailwind.functions'

type Props = {
  path?: string
  className?: string
  onClick?: () => void
}

const ProfileViewContainer = ({ path, className, onClick }: Props) => {
  return (
    <img
      onClick={onClick}
      src={path ?? '/profile-default.jpg'}
      alt="Profile"
      className={cn(
        'w-32 h-32 rounded-2xl object-cover col-span-2',
        { 'cursor-pointer': !!onClick },
        className
      )}
    />
  )
}

export default ProfileViewContainer
